import { Controller } from 'stimulus';
import { ezResourceGrid } from 'ez-styles/assets/javascripts/ez-styles/justified-grid';

require('intersection-observer');

export default class ResourcesGridController extends Controller {
  connect() {
    this.initGrid();

    this.element.addEventListener('InitGrid', this.initGrid);
  }

  initGrid = () => {
    ezResourceGrid(this.element, {
      rowHeight: parseInt(this.element.getAttribute('data-row-height'), 10),
      maxRows: parseInt(this.element.getAttribute('data-max-rows'), 10),
      truncate: !!this.element.getAttribute('data-truncate-results'),
    });

    if (this.data.get('lazy') === 'true') {
      this.loadLazy(this.element.getAttribute('data-lazy-offset'));
    }
  }

  loadLazy(lazyLoadOffset) {
    const lazyImages = [].slice.call(this.element.querySelectorAll('.ez-resource-thumb__img'));

    if ('IntersectionObserver' in window) {
      const lazyImageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.lazySrc;
            lazyImage.srcset = lazyImage.dataset.lazySrcset;
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      }, { rootMargin: `0px 0px ${lazyLoadOffset}px 0px` });

      lazyImages.forEach((lazyImage) => {
        lazyImageObserver.observe(lazyImage);
      });
    } else { // We should not get here as we use polyfill
      console.error('Intersection observer not supported');
    }
  }
}
